import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { CloseButton, ContentWrapper, ModalBody, ModalHeader } from '../mapView/mapView.style';
import Modal from '../../../components/uielements/modal';
import { IntlMessages } from '../../../helper/langHelper';

const ZoneErrorModal = ({ isModalOpen, onClose, address }) => {
  const closeButtonRef = useRef(null);
  const modalRef = useRef(null);
  const lastFocusedElement = useRef(null);

  // Handle focus management for accessibility
  useEffect(() => {
    if (isModalOpen) {
      lastFocusedElement.current = document.activeElement;
      setTimeout(() => closeButtonRef.current?.focus(), 100);
    } else if (lastFocusedElement.current) {
      lastFocusedElement.current.focus();
    }
  }, [isModalOpen]);

  const handleKeyDown = (event) => {
    if (!isModalOpen) return;

    if (event.key === 'Escape') {
      onClose();
    }

    if (event.key === 'Tab') {
      const focusableElements = modalRef.current?.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (!focusableElements) return;

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey) {
        if (document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }
  };

  return (
    <Modal
      isOpen={isModalOpen}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      onKeyDown={handleKeyDown}
      ref={modalRef}
    >
      <ModalHeader>
        <h3 id="modal-title">
          <IntlMessages id="application.notice" />
        </h3>
        <CloseButton
          onClick={onClose}
          ref={closeButtonRef}
          aria-label="Close property overlays"
          type="button"
        >
          <X size={24} aria-hidden="true" />
        </CloseButton>
      </ModalHeader>{' '}
      <ModalBody id="modal-description">
        <ContentWrapper>
          <IntlMessages id="zone.not.available" values={{ address }} />
        </ContentWrapper>
      </ModalBody>
    </Modal>
  );
};

export default ZoneErrorModal;
